import BaseLayout from '@/components/BaseLayout.vue'
import { mapGetters } from 'vuex';

export default {
    name: 'home',

    components: {
        BaseLayout
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),

        /**
         * Genrate link for end promotion
         * Dermo is different then other two
         *
         * @return {string}
         */
        endPromotionLink() {
            if (this.promotion.activePromotion.type.id === 3) {
                return 'promotion/completion/dermo';
            }

            return 'promotion/completion'
        }
    },
}